mover = function () {

  let moveUpBtn = document.querySelectorAll('.btn-up');
  let moveDownBtn = document.querySelectorAll('.btn-down');

  /**
   * Add event listeners to all .btn-up elements.
   */
  for (let i = 0; i < moveUpBtn.length; i++) {
    moveUpBtn[i].addEventListener('click', function () {
      let parent = this.parentElement;

      if (parent.previousElementSibling) {
        parent.parentNode.insertBefore(parent, parent.previousElementSibling);
      }
    });

    moveUpBtn[i].classList.remove('btn-up');
  }

  /**
   * Add event listeners to all .btn-down elements.
   */
  for (let i = 0; i < moveDownBtn.length; i++) {
    moveDownBtn[i].addEventListener('click', function () {
      let parent = this.parentElement;

      if (parent.nextElementSibling) {
        parent.parentNode.insertBefore(parent.nextElementSibling, parent);
      }
    });

    moveDownBtn[i].classList.remove('btn-down');
  }
}